// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"285":"app-messages-fr_CA","1539":"question-sets-metadata","3546":"app-messages-en_CA"}[chunkId] + "." + {"285":"f6352202","1539":"7f2f81b5","3546":"d7ba43ce"}[chunkId] + ".chunk.js";
};